import { createApiClient } from "#/shared/api/client";

/**
 * Hands a record's fields to Clara through the admin's machine-translation endpoint, which answers
 * `{ count, message }` for the pairs it queued or `{ count: 0, error }` when it queued none.
 *
 * @param {Object} options
 * @param {String} options.translateUrl
 * @param {String} options.resourceType
 * @param {String|Number} options.resourceId
 */
export const createMachineTranslationsApi = ({ translateUrl, resourceType, resourceId }) => {
  const api = createApiClient({ parse: false });

  return {
    requestTranslations: ({ attributeNames, locales, replace }) =>
      api.post(translateUrl, {
        resource_type: resourceType,
        resource_id: resourceId,
        attribute_names: attributeNames,
        locales,
        replace,
      }),
  };
};
